/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable new-parens */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';

import { ICON } from '../config/icons';
import { elexity } from '../utilities/AdvancedGraphHelper';
import elexity_logo from '../assets/elexity_logo_orange.svg';

import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

import MenuIcon from './icons/MenuIcon';
import CloseIcon from './icons/CloseIcon';
import ComfortIcon from './icons/ComfortIcon';
import EnergyIcon from './icons/EnergyIcon';
import DevicesIcon from './icons/DevicesIcon';
import BatteryIconNav from './icons/BatteryIconNav';
import EvIconNav from './icons/EvIconNav';

import TrendsIcon from './icons/TrendsIcon';
import SolarIcon from './icons/SolarIcon';
import ScheduleIcon from './icons/ScheduleIcon';
import ResourcesIcon from './icons/ResourcesIcon';
import SettingsIcon from './icons/SettingsIcon';
import LogoutIcon from './icons/LogoutIcon';

import { ReactComponent as NotificationsIcon } from '../assets/icon_notifications.svg';
import icon_email from '../assets/icon_email.svg';
import icon_menu from '../assets/icon_menu.svg';
import icon_phone from '../assets/icon_phone.svg';
import withRouter from '../utilities/WithRouter';
import authentication from '../utilities/Authentication';
import configuration from '../config';
import AuthenticatedComponent from '../utilities/AuthenticatedComponent';
import { PermissionBlock } from '../features/permissions/PermissionBlock';

import {
  setCurrentCampus,
  setCurrentBuilding,
  setCurrentGX,
  setCurrentGXData,
  setCurrentZone,
  updateCurrentCampusData,
} from '../actions';

const SideNav = ({
  setCurrentCampus,
  setCurrentBuilding,
  setCurrentZone,
  setCurrentGX,
  updateCurrentCampusData,
  router,
  campuses,
  currentCampusId,
  currentUserData,
  activePage,
  setActivePage,
  currentWindowSize,
  showMobile,
  showSolarIcon,
}) => {
  const { appConfig } = useContext(AppContext);

  const authenticatedComponent = new AuthenticatedComponent();
  const getHeader = authenticatedComponent.generateAuthenticatedHeader();
  const overlayRef = useRef(null);
  const firstName = currentUserData?.firstName ? currentUserData['first_name'] : '';

  const [showSidenav, setShowSidenav] = useState(false);
  const [sideNavClass, setSideNavClass] = useState(
    showMobile ? 'sidenav mobile mobile-hide' : 'sidenav hide'
  );

  useEffect(() => {
    resetMenu();
    window.addEventListener('click', hideSidenav);

    return () => {
      window.removeEventListener('click', hideSidenav);
    };
  }, []);

  useEffect(() => {
    resetMenu();
  }, [currentWindowSize, currentCampusId]);

  const navigateWithValidation = (newPath) => {
    if (router.location.pathname !== newPath) {
      router.navigate(newPath);
    }
  };

  function hideSidenav(e) {
    if (e.target === overlayRef.current) {
      resetMenu();
    }
  }

  function resetCampus() {
    setCurrentBuilding(null);
    setCurrentZone(null);
    setCurrentGX(null);
  }

  function resetMenu() {
    if (showMobile) {
      setShowSidenav(false);
      setSideNavClass('sidenav mobile mobile-hide');
    } else {
      setShowSidenav(false);
      setSideNavClass('sidenav hide');
    }

    navigateWithValidation(router.location.pathname);
  }

  const onOptionChange = (newCampusId) => {
    setCurrentCampus(newCampusId);

    if (currentCampusId !== newCampusId) {
      fetch(configuration['backend_host'] + '/ahiapi/' + newCampusId + '/campus/comfort', {
        headers: getHeader,
      })
        .then((response) => response.json())

        .then((data) => {
          updateCurrentCampusData(data);
        })

        .catch((error) => console.error(error));
    }

    if (activePage === 'scheduler') {
      navigateWithValidation(
        `/${activePage}/` + newCampusId + `/${router.location.pathname.split('/')[3]}`
      );
    } else if (activePage === 'ev' || activePage === 'battery') {
      navigateWithValidation(`/devices/` + newCampusId + `/${activePage}`);
    } else {
      navigateWithValidation(`/${activePage}/` + newCampusId);
    }

    elexity.admin.monitor.graphs.halt();
    setShowSidenav(false);
  };

  const handleCampusChange = (e) => {
    onOptionChange(e.target.value);
    resetCampus();
  };

  const handlePageChange = (e, page) => {
    e.stopPropagation();

    elexity.admin.monitor.graphs.halt();
    setActivePage(page);
    resetCampus();

    if (page === 'energy') {
      setCurrentBuilding(null);
      setCurrentZone(null);
    } else {
      setCurrentGX(null);
    }

    if (showSidenav) {
      setShowSidenav(false);
      setSideNavClass('sidenav hide');

      if (showMobile) {
        resetMenu();
      }
    }
  };

  const handleMenuClick = (e, type) => {
    e.stopPropagation();

    //don't close if selecting a campus
    if (e.target.tagName !== 'SELECT') {
      if (showMobile) {
        setShowSidenav(!showSidenav);
        setSideNavClass(!showSidenav ? 'sidenav mobile' : 'sidenav mobile mobile-hide');
      } else {
        setShowSidenav(type === 'close' ? false : true);
        setSideNavClass(type === 'close' ? 'sidenav hide' : 'sidenav');
      }
    }
  };

  const renderProfileInfo = () => {
    if (currentUserData) {
      return (
        <>
          <div className="user-container">
            <div className="sidenav-profile-name">
              Welcome{firstName !== '' ? `, ${firstName}` : '!'}
            </div>
          </div>
        </>
      );
    }
    return false;
  };

  return (
    <>
      <StyledSideNavDiv>
        {showMobile && (
          <div className={showSidenav ? 'mobile-nav active' : 'mobile-nav'}>
            <div className="mobile-menu-button" onClick={handleMenuClick}>
              <MenuIcon fill="none" strokeColor="#FFFFFF" strokeWidth={3} width="18px" />
            </div>

            <img src={elexity_logo} alt="elexity logo" width="142" height="32" />
          </div>
        )}

        <div className={sideNavClass}>
          <div className="sidenav-main-container" onClick={handleMenuClick}>
            <div className="sidenav-top">
              <div className="elexity-logo">
                <img src={ICON.UI.ELEXITY_LOGO_WIDE} alt="elexity logo" width="142" height="32" />

                <div className="close" onClick={(e) => handleMenuClick(e, 'close')}>
                  <CloseIcon
                    backgroundFill="none"
                    fillColor="none"
                    strokeColor="#F8f9FB"
                    strokeWidth={3}
                    width="18px"
                  />
                </div>
              </div>

              {renderProfileInfo()}

              <div className="campus-dropdown">
                <select
                  className="campus-menu"
                  onChange={handleCampusChange}
                  value={currentCampusId === null ? '' : currentCampusId}
                >
                  <option value="" disabled>
                    Select a Campus
                  </option>
                  {campuses &&
                    campuses.map((campus) => (
                      <option
                        key={`side-bar-${campus.campusEntityKey}`}
                        value={campus.campusEntityKey}
                      >
                        {campus.shortCampusDisplayName}
                      </option>
                    ))}
                </select>
              </div>

              <NavLink
                className={
                  activePage === 'comfort' ? 'sidenav-link comfort active' : 'sidenav-link comfort'
                }
                to={`/comfort/${currentCampusId}`}
                onClick={(e) => handlePageChange(e, 'comfort')}
              >
                <div className="menu-icon">
                  <ComfortIcon
                    backgroundFill="none"
                    fillColor={activePage === 'comfort' ? '#FEB02F' : '#F8f9FB'}
                    strokeColor={activePage === 'comfort' ? '#FEB02F' : '#F8f9FB'}
                    strokeWidth={activePage === 'comfort' ? 2.5 : 2}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Comfort</div>
              </NavLink>

              <NavLink
                className={
                  activePage === 'energy' ? 'sidenav-link energy active' : 'sidenav-link energy'
                }
                to={`/energy/${currentCampusId}`}
                onClick={(e) => handlePageChange(e, 'energy')}
              >
                <div className="menu-icon">
                  <EnergyIcon
                    backgroundFill={activePage === 'energy' ? '#FEB02F' : 'none'}
                    fillColor={activePage === 'energy' ? '#FEB02F' : '#F8f9FB'}
                    strokeColor={activePage === 'energy' ? '#FEB02F' : '#F8f9FB'}
                    strokeWidth={activePage === 'energy' ? 1 : 2}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Energy</div>
              </NavLink>

              <NavLink
                className={activePage === 'ev' ? 'sidenav-link ev active' : 'sidenav-link ev'}
                to={`/devices/${currentCampusId}/ev`}
                onClick={(e) => handlePageChange(e, 'ev')}
              >
                <div className="menu-icon">
                  <EvIconNav
                    backgroundFill="none"
                    fillColor={activePage === 'ev' ? '#FEB02F' : '#F8f9FB'}
                    width="18px"
                  />
                </div>

                <div className="menu-name">EV</div>
              </NavLink>

              <NavLink
                className={
                  activePage === 'battery' ? 'sidenav-link battery active' : 'sidenav-link devices'
                }
                to={`/devices/${currentCampusId}/battery`}
                onClick={(e) => handlePageChange(e, 'battery')}
              >
                <div className="menu-icon">
                  <BatteryIconNav
                    backgroundFill="none"
                    fillColor={activePage === 'battery' ? '#FEB02F' : '#F8f9FB'}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Battery</div>
              </NavLink>

              <NavLink
                className={
                  activePage === 'trends' ? 'sidenav-link trends active' : 'sidenav-link trends'
                }
                to={`/trends/${currentCampusId}`}
                onClick={(e) => handlePageChange(e, 'trends')}
              >
                <div className="menu-icon">
                  <TrendsIcon
                    backgroundFill="none"
                    fillColor="none"
                    strokeColor={activePage === 'trends' ? '#FEB02F' : '#F8f9FB'}
                    strokeWidth={activePage === 'trends' ? 2.75 : 2}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Trends</div>
              </NavLink>

              {showSolarIcon && (
                <>
                  <NavLink
                    className={
                      activePage === 'solar' ? 'sidenav-link solar active' : 'sidenav-link solar'
                    }
                    to={`/solar/${currentCampusId}`}
                    onClick={(e) => handlePageChange(e, 'solar')}
                  >
                    <div className="menu-icon">
                      <SolarIcon
                        fillColor={activePage === 'solar' ? '#FEB02F' : 'none'}
                        strokeColor={activePage === 'solar' ? '#FEB02F' : '#F8f9FB'}
                        strokeWidth={activePage === 'solar' ? 2.75 : 2.5}
                        circleStrokeWidth={activePage === 'solar' ? 0 : 2}
                        width="18px"
                      />
                    </div>

                    <div className="menu-name">Solar</div>
                  </NavLink>
                </>
              )}

              {appConfig?.sections?.comfort?.hasZones && (
                <PermissionBlock>
                  <NavLink
                    className={
                      activePage === 'scheduler'
                        ? 'sidenav-link scheduler active'
                        : 'sidenav-link scheduler'
                    }
                    to={`/scheduler/${currentCampusId}/schedules`}
                    onClick={(e) => handlePageChange(e, 'scheduler')}
                  >
                    <div className="menu-icon">
                      <ScheduleIcon
                        backgroundFill="none"
                        fillColor="none"
                        strokeColor={activePage === 'scheduler' ? '#FEB02F' : '#F8f9FB'}
                        strokeWidth={activePage === 'scheduler' ? 2.5 : 2}
                        width="18px"
                      />
                    </div>

                    <div className="menu-name">Scheduler</div>
                  </NavLink>
                </PermissionBlock>
              )}

              <NavLink
                className={
                  activePage === 'resources'
                    ? 'sidenav-link resources active'
                    : 'sidenav-link resources'
                }
                to={'/resources'}
                onClick={(e) => handlePageChange(e, 'resources')}
              >
                <div className="menu-icon">
                  <ResourcesIcon
                    backgroundFill={activePage === 'resources' ? '#FEB02F' : 'none'}
                    outerStrokeColor={activePage === 'resources' ? '#FEB02F' : '#F8f9FB'}
                    innerStrokeColor={activePage === 'resources' ? '#02222B' : '#F8f9FB'}
                    strokeWidth={activePage === 'resources' ? 2.5 : 2}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Resources</div>
              </NavLink>

              {showSidenav && (
                <div className="subnav-resources">
                  <span>Support</span>

                  <div className="support-details">
                    <p>Hours: 9am - 5pm (PST)</p>
                    <p>
                      Callback within:
                      <br />
                      1 hour (Weekdays)
                      <br />4 hours (Weekends)
                    </p>
                  </div>

                  <div className="contact">
                    <a href="mailto:support@elexity.io" className="email-us">
                      <img src={icon_email} alt="email icon" width="14" height="14" />
                      support@elexity.io
                    </a>

                    <a href="tel:5102259329" className="call-us">
                      <img src={icon_phone} alt="phone icon" width="14" height="14" />
                      510-225-9329
                    </a>
                  </div>
                </div>
              )}
            </div>

            <div className="sidenav-bottom">
              <NavLink
                className={
                  activePage === 'settings'
                    ? 'sidenav-link settings active'
                    : 'sidenav-link settings'
                }
                to={'/settings'}
                onClick={(e) => handlePageChange(e, 'settings')}
              >
                <div className="menu-icon">
                  <SettingsIcon
                    backgroundFill={activePage === 'settings' ? '#FEB02F' : 'none'}
                    fillColor={activePage === 'settings' ? '#2A4147' : 'none'}
                    strokeColor={activePage === 'settings' ? '#FEB02F' : '#F8f9FB'}
                    strokeWidth={activePage === 'settings' ? 0 : 2}
                    width="19px"
                  />
                </div>

                <div className="menu-name">Settings</div>
              </NavLink>

              {/* <NavLink
              className='sidenav-link notifications'
              to={'/notifications'}
              onClick={() => handlePageChange('notifications')}
            >
              <div className='menu-icon'>
                <NotificationsIcon />
              </div>

              <div className="menu-name">
                Notifications
              </div>
            </NavLink> */}

              <a
                className="sidenav-link logout"
                onClick={authentication.logout}
                href={authentication.logoutLink}
              >
                <div className="menu-icon">
                  <LogoutIcon
                    backgroundFill="none"
                    fillColor="none"
                    strokeColor="#F8f9FB"
                    strokeWidth={2}
                    width="18px"
                  />
                </div>

                <div className="menu-name">Log Out</div>
              </a>
            </div>
          </div>
        </div>

        <div
          className={showSidenav ? 'sidenav-overlay show' : 'sidenav-overlay'}
          ref={overlayRef}
        ></div>
      </StyledSideNavDiv>
    </>
  );
};

const StyledSideNavDiv = styled.div`
  .sidenav-overlay.show {
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    background: rgba(52, 64, 84, 0.6);
    bottom: 0;
    display: block;
    height: 100vh;
    left: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    transition: ease-in-out all 350ms;
    z-index: 100;
  }

  .sidenav {
    background: #02222b;
    border-radius: 0 12px 12px 0;
    cursor: pointer;
    height: 100vh;
    position: absolute;
    text-align: left;
    transition: ease-in-out all 250ms;
    width: 300px;
    z-index: 101;

    //HIDDEN SIDENAV BEGIN//
    &.hide {
      min-width: unset;
      transition: ease-in-out all 250ms;
      width: 86px;

      .sidenav-main-container,
      .sidenav-main-container .campus-dropdown,
      .sidenav-main-container .menu-name {
        overflow: hidden;
        transition: ease-in-out width 250ms;
      }

      .sidenav-main-container {
        .sidenav-top,
        .sidenav-bottom {
          overflow: hidden;
          width: 36px;
        }

        .campus-dropdown {
          width: 0;
        }

        .sidenav-link {
          &.active {
            background: transparent;

            .menu-icon {
              background: #2a4147;
            }
          }
        }
      }

      .subnav-resources {
        display: none;
      }
    }
    //HIDDEN SIDENAV END//

    .sidenav-main-container {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      height: calc(100% - 48px);
      justify-content: space-between;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 24px 25px 0;
      transition: ease-in-out width 800ms;

      .sidenav-link {
        align-items: center;
        background-color: transparent;
        border-radius: 8px;
        color: #f8f9fb;
        display: flex;
        font-weight: 500;
        height: 36px;
        justify-content: flex-start;
        width: 252px;

        &.active {
          background: #2a4147;
          border-radius: 8px;
          color: #feb02f;
          font-weight: 800;
        }

        &.resources .menu-name {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-right: 6px;
          width: 100%;
        }

        .menu-icon {
          align-items: center;
          background: transparent;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          margin-right: 6px;
          padding: 9px;
        }
      }

      .sidenav-top,
      .sidenav-bottom {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: 1vh;
        justify-content: flex-start;
        width: 100%;
      }

      .campus-dropdown select {
        box-shadow: none;
        margin-bottom: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 252px;
      }

      .campus-menu {
        color: #02222b;
        font-size: 14px;
      }

      .subnav-resources {
        display: flex;
        flex-direction: column;
        font-size: 12px;
        padding-left: 40px;

        span,
        a,
        p {
          color: #b6d1d7;
        }

        span {
          font-weight: 600;
        }

        span,
        p {
          margin: 0 0 5px;
        }

        a {
          align-items: center;
          display: flex;
          justify-content: flex-start;
          margin: 6px 12px;
          text-decoration: underline;

          img {
            padding-right: 6px;
          }
        }

        .contact {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }

      .elexity-logo {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-left: 4px;
        width: 100%;
      }
    }

    .close {
      align-items: center;
      display: flex;
      height: 24px;
      justify-content: center;

      p {
        color: #f8f9fb;
      }
    }
  }

  //MOBILE STYLES
  .sidenav.mobile {
    border-radius: 0;
    transition: ease-in-out all 250ms;
    width: 100%;

    .sidenav-main-container {
      align-items: center;
    }

    &.mobile-hide {
      display: none;
      transition: ease-in-out all 250ms;
    }
  }
  .mobile-nav {
    align-items: center;
    background: #02222b;
    display: flex;
    padding: 12px 24px;
    width: calc(100% - 48px);
    z-index: 10;

    img {
      margin: 0 auto;
    }

    .mobile-menu-button {
      cursor: pointer;
      overflow: hidden;
    }

    &.active {
      display: none;
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    campuses: state.campuses,
    currentCampusId: state.currentCampusId,
    currentBuildingId: state.currentBuildingId,
    currentZoneId: state.currentZoneId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    currentGXData: state.currentGXData,
    currentUserData: state.currentUserData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentBuilding: (buildingId) => {
      dispatch(setCurrentBuilding(buildingId));
    },
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
    setCurrentGXData: (gxData) => {
      dispatch(setCurrentGXData(gxData));
    },
    setCurrentZone: (zoneId) => {
      dispatch(setCurrentZone(zoneId));
    },
    updateCurrentCampusData: (campusData) => {
      dispatch(updateCurrentCampusData(campusData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SideNav));
